import React from "react";
import {
  Container,
  Typography,
  Box,
  useTheme,
  alpha,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FilterListIcon from "@mui/icons-material/FilterList";
import DownloadIcon from "@mui/icons-material/Download";
import ShareIcon from "@mui/icons-material/Share";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FeatureLayout from "./FeatureLayout";

// App screenshot placeholders
import dashboardScreenshot1 from "../../../images/features/dashboard-1.png";
import dashboardScreenshot2 from "../../../images/features/dashboard-2.png";

const MultiPropertyDashboard = () => {
  const theme = useTheme();

  const benefits = [
    {
      icon: <AnalyticsIcon />,
      title: "Real-Time Analytics",
      description: "Track cleaning frequency, costs, and quality across all properties.",
    },
    {
      icon: <VisibilityIcon />,
      title: "Unified View",
      description: "See all your properties and their cleaning status in one screen.",
    },
    {
      icon: <FilterListIcon />,
      title: "Smart Filters",
      description: "Filter by property, cleaner, date, or status. Find what you need fast.",
    },
    {
      icon: <DownloadIcon />,
      title: "Export Reports",
      description: "Download cleaning history and financial reports for accounting.",
    },
    {
      icon: <ShareIcon />,
      title: "Team Access",
      description: "Share dashboard access with co-hosts and property managers.",
    },
    {
      icon: <DashboardIcon />,
      title: "Customizable Views",
      description: "Arrange your dashboard to show what matters most to you.",
    },
  ];

  const stats = [
    { value: "Unlimited", label: "Properties" },
    { value: "Real-time", label: "Updates" },
    { value: "1-click", label: "Reports" },
    { value: "24/7", label: "Access" },
  ];

  return (
    <FeatureLayout
      title="Multi-Property Dashboard"
      subtitle="Manage everything from one central hub"
      description="Whether you have 1 property or 100, our dashboard gives you complete visibility. Track cleaning status, costs, schedules, and cleaner performance - all in one place."
      icon={<DashboardIcon sx={{ fontSize: 32 }} />}
      iconGradient="linear-gradient(135deg, #fa709a, #fee140)"
      breadcrumbs={[
        { label: "Features", link: "/features" },
        { label: "Multi-Property Dashboard" },
      ]}
      benefits={benefits}
      stats={stats}
      imageRight={dashboardScreenshot1}
      imageLeft={dashboardScreenshot2}
    />
  );
};

export default MultiPropertyDashboard;